import {badgeColor, flagsTranslate} from 'src/constants';
import {Badge} from 'src/types/tag';
import {UserStories, UserStory as UserStoryType} from 'src/types/epic';

type UserStoryProps = {
    userstory: UserStoryType;
    userstories: UserStories;
    clickHandler: (e: UserStoryType, userStories: UserStories) => void;
}
export const UserStoryItem = ({clickHandler, userstories, userstory}: UserStoryProps) => {
    return (
        <div
            className="flex flex-col items-start"
            onClick={() => {
                clickHandler(userstory, userstories)
            }}
        >
            <h3 className="w-full text-right flex flex-wrap">
                <span>{userstory?.subject}</span>
                {!!userstory?.assigned_to_extra_info?.full_name_display && (
                    <div className="flex">
            <span className="badge badge-warning badge-sm p-2 mr-2">
              {userstory?.assigned_to_extra_info.full_name_display}
            </span>
                    </div>
                )}
            </h3>
            <div className="flex">
                {userstory.tags?.map((tag) => {
                    const tagName = Object.entries(flagsTranslate).find((item) => item[1] === tag[0]);

                    if (tag) {
                        return (
                            <span
                                className={`badge rounded-full badge-outline p-2 ml-2 ${tagName ? badgeColor[tagName[0] as keyof Badge] : ''
                                }`}
                                key={tag[0]}
                            >
                {tag[0]}
              </span>
                        );
                    } else {
                        return null;
                    }
                })}
            </div>
        </div>
    )
}
